(function () {
  const BLOCK = "guarantee-modal";
  const VISIBLE_CLASS = `${BLOCK}--visible`;
  const TRANSITION_MS = 300;

  let hideTimer = null;
  let opener = null;

  function getModal() {
    const modal = document.querySelector("[data-guarantee-modal]");

    /* The header is sticky/transformed, which breaks position: fixed for descendants. */
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);

    return modal;
  }

  function onKeydown(event) {
    if (event.key === "Escape") close();
  }

  function open(trigger) {
    const modal = getModal();
    if (!modal) return;

    clearTimeout(hideTimer);
    opener = trigger;
    modal.hidden = false;

    requestAnimationFrame(() => modal.classList.add(VISIBLE_CLASS));

    document.documentElement.style.overflow = "hidden";
    document.addEventListener("keydown", onKeydown);

    const closeButton = modal.querySelector("[data-guarantee-modal-close]");
    if (closeButton) closeButton.focus();
  }

  function close() {
    const modal = getModal();
    if (!modal || !modal.classList.contains(VISIBLE_CLASS)) return;

    modal.classList.remove(VISIBLE_CLASS);
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", onKeydown);

    hideTimer = setTimeout(() => {
      modal.hidden = true;
    }, TRANSITION_MS);

    if (opener) opener.focus();
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-guarantee-modal-open]");

    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (
      event.target.closest("[data-guarantee-modal-close]") ||
      (event.target.closest("[data-guarantee-modal]") && !event.target.closest(`.${BLOCK}__dialog`))
    ) {
      close();
    }
  });
})();
